/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TransportAutoCarFrontIcon16Light } from './TransportAutoCarFrontIcon16Light';
import { TransportAutoCarFrontIcon16Regular } from './TransportAutoCarFrontIcon16Regular';
import { TransportAutoCarFrontIcon16Solid } from './TransportAutoCarFrontIcon16Solid';
import { TransportAutoCarFrontIcon20Light } from './TransportAutoCarFrontIcon20Light';
import { TransportAutoCarFrontIcon20Regular } from './TransportAutoCarFrontIcon20Regular';
import { TransportAutoCarFrontIcon20Solid } from './TransportAutoCarFrontIcon20Solid';
import { TransportAutoCarFrontIcon24Regular } from './TransportAutoCarFrontIcon24Regular';
import { TransportAutoCarFrontIcon24Solid } from './TransportAutoCarFrontIcon24Solid';
import { TransportAutoCarFrontIcon32Regular } from './TransportAutoCarFrontIcon32Regular';
import { TransportAutoCarFrontIcon64Regular } from './TransportAutoCarFrontIcon64Regular';
var sizes = {
    16: {
        light: TransportAutoCarFrontIcon16Light,
        regular: TransportAutoCarFrontIcon16Regular,
        solid: TransportAutoCarFrontIcon16Solid,
    },
    20: {
        light: TransportAutoCarFrontIcon20Light,
        regular: TransportAutoCarFrontIcon20Regular,
        solid: TransportAutoCarFrontIcon20Solid,
    },
    24: {
        regular: TransportAutoCarFrontIcon24Regular,
        solid: TransportAutoCarFrontIcon24Solid,
    },
    32: {
        regular: TransportAutoCarFrontIcon32Regular,
    },
    64: {
        regular: TransportAutoCarFrontIcon64Regular,
    },
};
export var TransportAutoCarFrontIcon = forwardRef('TransportAutoCarFrontIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
